export const TOOL_TYPES = {
  PAINT: "PAINT",
  COLOR_PICK: "COLOR_PICK",
  ERASE: "ERASE"
}